import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDotGrid1x3Vertical: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="dot-grid-1x3-vertical, menu, drag, grab"><path d="M11 2.75H13V4.75H11V2.75Z" fill="currentColor"/><path d="M13 11H11V13H13V11Z" fill="currentColor"/><path d="M11 19.25H13V21.25H11V19.25Z" fill="currentColor"/><path d="M11 2.75H13V4.75H11V2.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M13 11H11V13H13V11Z" stroke="currentColor" strokeWidth="1.5"/><path d="M11 19.25H13V21.25H11V19.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconDotGrid1x3Vertical;
